<template>
  <div class="page" v-loading="listLoading">
    <el-form :inline="true" @submit.native.prevent>
      <el-form-item label="审批结果:">
        <el-select v-model="searchData.Status" placeholder="请选择">
          <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间">
        <el-date-picker v-model="datePicker" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handlePicker"
                        style="width:100%">
        </el-date-picker>
      </el-form-item>
      <!--        <el-col :span="6">-->
      <!--          <el-form-item label="商品名称:">-->
      <!--            <el-input v-model="searchData.proName" placeholder="请输入商品名称" clearable></el-input>-->
      <!--          </el-form-item>-->
      <!--        </el-col>-->
      <!--        <el-col :span="6">-->
      <!--          <el-form-item label="商品品牌：">-->
      <!--            <el-input v-model="searchData.brandName" placeholder="请输入商品品牌" clearable></el-input>-->
      <!--          </el-form-item>-->
      <!--        </el-col>-->
      <!--      <el-form-item label="商品型号:">-->
      <!--        <el-input style="width: 220px;" v-model="searchData.modelCode" placeholder="请输入型号" clearable></el-input>-->
      <!--      </el-form-item>-->

      <el-form-item>
        <div class="flex">
          <el-button type="primary" @click="searchFun">查询</el-button>
          <el-button @click="resetFun">重置</el-button>
<!--          <toolbar class="mgl10" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>-->
        </div>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table v-loading="loading" :data="tableData" highlight-current-row element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
              @selection-change="selectCurrentRow" style="width: 100%" border>
      <!-- <el-table-column type="selection" width="50" fixed align="center"></el-table-column> -->
      <el-table-column prop="amount" label="金额"  align="center">
        <template slot-scope="scoped">
          {{ `￥` + scoped.row.amount }}
        </template>
      </el-table-column>
      <el-table-column prop="creationTime" label="申请时间" align="center"></el-table-column>
<!--      <el-table-column prop="" label="申请人"  align="center"></el-table-column>-->
      <el-table-column prop="status" label="审批结果"  align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 0">未审批</el-tag>
          <el-tag v-if="scope.row.status == 1" type="success">已通过</el-tag>
          <el-tag v-if="scope.row.status == 2" type="danger">已拒绝</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="auditTime" label="审核时间"  align="center"></el-table-column>
      <!-- <el-table-column label="商家型号" prop="model" width="120" align="center"></el-table-column> -->
<!--      <el-table-column width="200" label="操作" fixed="right" align="center">-->
<!--        <template slot-scope="scope">-->
<!--          <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"-->
<!--                     @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}-->
<!--          </el-button>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>
    <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                   @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]">
    </el-pagination>
  </div>
</template>

<script>
import {getButtonList} from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import {GetFrozenRecordList, WithdrawalOrderGetList} from "../../api/api";

export default {
  components: {Toolbar},
  props:{
    sellerId:{
      type: Number,
      default:null
    }
  },
  data() {
    return {
      tableData:[],
      loading: false,
      datePicker:[],
      options: [{
        value: '0',
        label: '未审批'
      }, {
        value: '1',
        label: '通过'
      }, {
        value: '2',
        label: '拒绝'
      }, {
        value: null,
        label: '全部'
      }],
      value: '',
      searchData: {
        Status: null,
        RecordType: null,
        StartTime: null,
        EndTime: null,
        pageIndex: 1, //页码
        pageSize: 10, //页长
        SkipCount: null,
        MaxResultCount: null,
      },
      total: 0,
      listLoading: false,
      currentRow: [],
      buttonList_toolBar: [],
      buttonList_table: [],
      tableList: [],
    };
  },
  created() {
    this.getList();
  },
  watch:{
    async sellerId (newVal, oldVal){
      if (oldVal !== null) {
        this.getList();
      }
      // console.log('new', 'old', newVal, oldVal)
      // this.ReSellerId = newVal
      // this.getList();
      // console.log('提款', this.ReSellerId);
      // let res = await WithdrawalOrderGetList({CapitalAccountId: newVal});
      // console.log('提现审核明细', res);
      // if (res.data.success){
      //   this.tableData = res.data.result.items
      // }else{
      //   this.$message.error(res.data.error.message)
      // }
    }
  },
  mounted() {
    let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      this.buttonList_toolBar = toolBarButtonList;
      const tableButtonList = buttonList.filter((item) => {
        return item.buttonShow === 20;
      });
      this.buttonList_table = tableButtonList;
    }
  },
  methods: {
    getList() {
      this.loading = true
      setTimeout(async () => {
        console.log('提款审核账户Id', this.sellerId)
        this.searchData.SkipCount = (this.searchData.pageIndex - 1) * this.searchData.pageSize;
        this.searchData.MaxResultCount = this.searchData.pageSize;
        this.searchData.CapitalAccountId = this.sellerId;
        this.ReSellerId = this.sellerId;
        let res = await WithdrawalOrderGetList(this.searchData);
        if (res.data.success) {
          this.loading = false
          this.tableData = res.data.result.items
          this.total = res.data.result.totalCount
        } else {
          this.loading = false
          this.$message.error(res.data.error.message)
        }
      }, 500)
    },
    handlePicker(val) {
      if (!val) {
        this.searchData.StartTime = ""
        this.searchData.EndTime = ""
      } else {
        this.searchData.StartTime = val[0]
        this.searchData.EndTime = val[1]
      }
    },
    copyBtn(item, index, row) {
      this.$router.push(`/Product/AddEditSpu?copyid=${row.spuId}`)
    },
   async searchFun() {
      this.searchData.pageIndex = 1;
      this.datePicker = []
      await this.getList();
    },
    resetFun() {
      this.searchData.pageIndex = 1;
      this.searchData.pageSize = 10;
      this.searchData.RecordType = null;
      this.searchData.StartTime = null;
      this.searchData.Status = null;
      this.searchData.EndTime = null;
      this.getList(this.searchData);
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    handleCurrentChange(val) {
      this.searchData.pageIndex = val;
      this.getList();
    },
    handleSizeChange(e) {
      this.searchData.pageSize = e;
      this.getList();
    },
    //获取商品列表
    getSpusOnSale() {
      this.listLoading = true;
      GetKSAXCommodityLibrary(this.searchData).then((res) => {
        if (res.data.success) {
          this.total = res.data.result.data.dataCount;
          this.tableList = res.data.result.data.data || [];
        } else {
          this.$message.error(res.data.msg)
        }
        setTimeout(() => {
          this.listLoading = false;
        }, 500)
      });
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   if (from.path == "/Product/ComManagement/EditProduct") {
  //     to.meta.keepAlive = true;
  //   } else {
  //     to.meta.keepAlive = false;
  //   }
  //   next();
  // },
};
</script>

<style scoped>
.updata_view {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
